import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureCardComponent } from './feature-card.component';
import { RouterLink } from '@angular/router';
import { MaterialModule } from '@/material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SwiperModule } from 'swiper/angular';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { SharedModule } from '../../shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [FeatureCardComponent],
  imports: [
    CommonModule,
    RouterLink,
    MaterialModule,
    PipesModule,
    NgxSpinnerModule,
    SwiperModule,
    NgxImageZoomModule,
    SharedModule,
    TranslateModule,
  ],
  exports: [FeatureCardComponent],
})
export class FeatureCardModule {}
